import React from 'react';
import { connect } from 'dva';

import {framework_tool} from '../../../tool'
let {WizContainer, templateUtils} = framework_tool;

class Template extends WizContainer {

  componentName = 'Template';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _buildKey = (key) => {
    return this.componentName + '@' + key
  }

  _paddingStyle = () => {
    return { margin: 20 }
  }

  _pageHeader = (title, subTitle, key) => {
    return { name: 'WizPageHeader', params: { key, title, subTitle, style: { border: '1px solid rgb(235, 237, 240)' } } }
  }

  _row(key, colParams) {
    let i = parseInt(24 / colParams)
    let r = []
    if (i > 0) {
      for (let index = 0; index < i; index++) {
        r.push(this._col(index, colParams))
      }
    }
    return {
      name: 'WizRow',
      params: { key, childrenParams: r }
    }
  }

  getRandomColor = () => {
    let colorStr = "";
    //字符串的每一字符的范围
    let randomArr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];
    //产生一个六位的字符串
    for (let i = 0; i < 6; i++) {
      //15是范围上限，0是范围下限，两个函数保证产生出来的随机数是整数
      colorStr += randomArr[Math.ceil(Math.random() * (15 - 0) + 0)];
    }
    return '#' + colorStr
  }

  _col(key, colParams) {
    let text = 'col-' + colParams
    let span = colParams
    return {
      name: 'WizCol',
      params: { key, span, children: text, style: { backgroundColor: this.getRandomColor() } }
    }
  }


  _custom() {
    return templateUtils.getComponentByConfig(
      {
        name: 'WizCard',
        params: {
          title: ' 卡片 ',
          style: { width: 300, margin: 30 },
          children: [
            <div>允许自定义的内容</div>,
            <div>允许自定义的内容</div>,
            <div>允许自定义的内容</div>
          ]
        }
      }
    )
  }


  _render() {
    return templateUtils.getComponentByConfig([
      //单组件配置
      this._pageHeader('评价', '通过配置生成的组件', this._buildKey('rate_page_header')),
      { 
        name: 'WizRate', 
        params: { key: 'WizRate', allowHalf: true, defaultValue: 2.5, style: this._paddingStyle() } },
      this._pageHeader('开关', '通过配置生成的组件', this._buildKey('switch_page_header')),
      { name: 'WizSwitch', params: { key: 'WizSwitch', checkedChildren: '开', unCheckedChildren: '关', defaultChecked: true, style: this._paddingStyle() } },
      this._pageHeader('头像', '通过配置生成的组件', this._buildKey('avatar_page_header')),
      { name: 'WizAvatar', params: { key: 'WizAvatar', src: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png', style: { height: 50, width: 50, ...this._paddingStyle() } } },
      this._pageHeader('进度条', '通过配置生成的组件', this._buildKey('progress_page_header')),
      { name: 'WizProgress', params: { key: 'WizProgress', type: 'circle', percent: 30, width: 80, style: { ...this._paddingStyle(), backgroundColor: '#ffffff' } } },
      //含内嵌组件的配置
      this._pageHeader('带children元素的展示', '通过配置生成的组件', this._buildKey('complex_page_header')),
      this._row('row-1', 12),
      this._row('row-2', 8),
      this._row('row-3', 6),
      //带自定义元素内嵌组件的配置
      this._pageHeader('自定义元素的展示', '通过配置生成的组件', this._buildKey('custom_page_header')),
      {
        name: 'WizCard',
        params: {
          title: ' 卡片 ',
          style: { width: 300, margin: 30 },
          children: [
            <div>允许自定义的内容</div>,
            <div>允许自定义的内容</div>,
            <div>允许自定义的内容</div>
          ]
        }
      },
      this._pageHeader('自定义元素的展示', '通过配置生成的组件', this._buildKey('custom_page_header')),
      {
        name: 'WizCard',
        params: {
          title: ' 卡片 ',
          style: { width: 300, margin: 30 },
          children: [
            <div>允许自定义的内容</div>,
            <div>允许自定义的内容</div>,
            <div>允许自定义的内容</div>
          ]
        }
      }
    ]);
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(Template);
